import { Grid, Grid2, Typography } from "@mui/material";
import { Commons } from "../../helper/CommonService";
import { QRCodeSVG } from 'qrcode.react';
import { useEffect, useState } from "react";
import { Downloads } from "../../helper/DownloadService";
import { API_HOST, BE_HOST, CONFIG_PENDAFTARAN, FOTO_HOST } from "../../helper/Constant";
import { MainIcon } from "../../helper/MainIcon";

const tahunAjaran = Commons.GetAuthDataInStorage("tahun_ajaran");

function PDFKartuPeserta({ dataSantri, dataBerkas }) {
    const [foto, setFoto] = useState();
    const [jadwalTest, setJadwalTest] = useState();
    useEffect(() => {
        Promise.all(
            [
                Commons.GetAdditionalInformation(CONFIG_PENDAFTARAN.TGL_TEST)
            ]
        ).then(([respJadwalTest]) => {
            setJadwalTest(respJadwalTest);
        })
    }, []);

    useEffect(() => {
        try {
            if (dataBerkas.foto_santri) {
                Downloads.GetBase64Image(FOTO_HOST + dataBerkas.foto_santri)
                    .then((respFoto) => {
                        setFoto(respFoto);
                    })
            }
        } catch (error) {
            console.log(error);
        }
    }, [dataBerkas]);
    if (!dataSantri) {
        return (
            <></>
        )
    }
    return (
        <>
            <Grid container>
                <Grid sx={{
                    padding: "5px", textAlign: "center", display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }} xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{ padding: "10px", border: "1px solid #000000" }}>
                        <table>
                            <tr>
                                <td align="right">
                                    <img style={{ height: "50px" }} src={MainIcon.MainLogo()}></img>
                                </td>
                                <td align="left">
                                    <b>
                                        PSB {tahunAjaran}
                                        <br></br>
                                        {dataSantri.jenjang_tujuan}
                                    </b>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={"2"} align="center">
                                    <img style={{ height: "250px" }} src={foto}></img>
                                    <br></br>
                                    <b>
                                        {dataSantri.no_daftar}
                                        <br></br>
                                        {dataSantri.nama}
                                    </b>
                                </td>
                            </tr>
                        </table>
                    </div>
                </Grid>
                <Grid sx={{ padding: "5px" }} xs={6} sm={6} md={6} lg={6} xl={6}>
                    <div style={{ padding: "10px", border: "1px solid #000000" }}>
                        <center>
                            <img style={{ height: "50px" }} src={MainIcon.MainLogo()}></img>
                            <br></br>
                            <QRCodeSVG
                                value={dataSantri.no_daftar} // The data to encode in the QR code
                                size={256}   // The size of the QR code
                                bgColor="#ffffff" // Background color
                                fgColor="#000000" // Foreground color
                                level="Q"   // Error correction level (L, M, Q, H)></QRCodeSVG>
                            />
                            <br></br>
                            <b>
                                {dataSantri.no_daftar}
                                <br></br>
                                {dataSantri.nama}
                                <br></br>
                                {jadwalTest}
                            </b>
                        </center>

                    </div>
                </Grid>
            </Grid>
            <Typography variant="h6" component="div" sx={{ mt: 5 }}>
                Penting!
                <br></br>
                <ol>
                    <li>ID Card Calon Santri dicetak ukuran 10x12cm, 2 muka, dilaminasi bening.</li>
                    <li>Tali gantungan warna kuning dan dikenakan selama berada di lingkungan Pesantren Baladz.</li>
                    <li>Calon Santri membawa alat tulis dan papan alat tulis/clipboard.</li>
                </ol>
            </Typography>
        </>
    )
}
export default PDFKartuPeserta;